import { URLS } from '../../../constants';
import apiClient from '../../client';

const getClinicianAndTechAPI = {
  getClinicianAndTech: () =>
    apiClient.post(URLS.getClinicianAndTech, {
      data: {},
    }),
};

export default getClinicianAndTechAPI;
